export default __webpack_public_path__ + "static/media/Sales_Intel_Technographics_2023.db48ae49.pdf";